import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Seal } from '../components/Seal';

/** Landing page — the seal, the motto, the one-line thesis, and the two doors: read, or apply. */
export default function Home() {
  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col items-center gap-10 px-6 py-20 text-center sm:py-28">
      <Seal variant="hero" className="h-28 w-28 sm:h-36 sm:w-36" />
      <div className="space-y-4">
        <h1 className="font-display text-3xl font-semibold uppercase tracking-[0.18em] text-ink sm:text-5xl">
          Original Illuminati
        </h1>
        <p className="font-serif text-xl italic text-muted sm:text-2xl">
          Scientia et Caritas — Knowledge &amp; Compassion
        </p>
      </div>

      <p className="max-w-prose font-serif text-lg text-ink sm:text-xl">
        A modern, open, non-profit network for people who value knowledge, reason, science, merit and
        compassion. Not a secret society — public statutes, open finances, documented decisions. Everyone
        who shares the values is welcome, and membership is free.
      </p>

      <div className="flex flex-col items-center gap-4 sm:flex-row">
        <Link
          to="/apply"
          className="inline-flex items-center gap-2 rounded-md border border-accent bg-accent px-6 py-3 font-sans text-sm font-semibold text-primary-deep transition-colors duration-150 ease-standard hover:bg-accent-deep hover:text-bg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
        >
          Apply for membership
          <ArrowRight aria-hidden className="h-4 w-4" />
        </Link>
        <Link
          to="/manifest"
          className="inline-flex items-center gap-2 rounded-md border border-border px-6 py-3 font-sans text-sm font-semibold text-ink transition-colors duration-150 ease-standard hover:bg-surface focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
        >
          Read the manifest
        </Link>
      </div>

      <p className="max-w-prose font-sans text-xs text-muted">
        Inspired by the Enlightenment and the historical order of 1776 — but making no claim to be it.
        <em> Aude sapere</em> — dare to know.
      </p>
    </div>
  );
}
